import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_table_cell = _resolveComponent("grid-table-cell")
  const _component_grid_table_row = _resolveComponent("grid-table-row")
  const _component_pledge_payment_history_modal_row = _resolveComponent("pledge-payment-history-modal-row")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_grid_table = _resolveComponent("grid-table")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "show-action-close": true,
    "is-visible": $props.isOpen,
    title: $options.title,
    width: "wide",
    onActionClose: $options.onClose,
    "data-qa": "Payment history"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_grid_table, { class: "_mt-3" }, {
        head: _withCtx(() => [
          _createVNode(_component_grid_table_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_grid_table_cell, { class: "_tal _flexb30 _flexb20--l" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Common.DateTableHeader), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_grid_table_cell, { class: "_tal gfu-table__cell--grow" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Common.PaymentMethodTableHeader), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_grid_table_cell, { width: 30 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Common.AmountTableHeader), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        body: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userPaymentHistory, (item) => {
            return (_openBlock(), _createBlock(_component_pledge_payment_history_modal_row, {
              key: item.paymentID,
              item: item,
              "data-qa": `payment-history-element:${item.itemId}`
            }, null, 8 /* PROPS */, ["item", "data-qa"]))
          }), 128 /* KEYED_FRAGMENT */)),
          (!$options.hasPaymentHistory)
            ? (_openBlock(), _createBlock(_component_empty_state, {
                key: 0,
                class: "_tac _mt-3",
                title: _ctx.Resources.YourPledge.PaymentHistoryModalEmptyStateText
              }, null, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "title", "onActionClose"]))
}